<template>
  <div class="trail-progress-line">
    <div class="track"></div>
    <div class="progress" :style="progressStyles"></div>
    <button class="badge" @click="onClickSeriesProgress">
      {{ progressText }}
    </button>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TrailProgressLine',

  /**
   * 属性
   */
  props: {
    trail: Object,
  },

  /**
   * 数据
   */
  data() {
    return {
      progressTextType: 'percent',
      showBadge: false,
      progress: 0,
    };
  },

  /**
   * 计算属性
   */
  computed: {
    progressText() {
      let progressText = '';

      if (this.progressTextType === 'percent') {
        progressText =
          this.trail.progress && this.trail.progress.percent
            ? `${this.trail.progress.percent}%`
            : '0%';
      }

      if (this.progressTextType === 'completed') {
        progressText =
          this.trail.progress && this.trail.progress.completed
            ? `${this.trail.progress.completed}节`
            : '0节';
      }

      return progressText;
    },

    progressStyles() {
      return {
        width: `${this.progress}%`,
      };
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 已挂载
   */
  mounted() {
    if (this.trail.progress) {
      setTimeout(() => {
        this.progress = this.trail.progress.percent;
      }, 200);
    }
  },

  /**
   * 组件方法
   */
  methods: {
    onClickSeriesProgress() {
      if (this.progressTextType === 'percent') {
        this.progressTextType = 'completed';
      } else {
        this.progressTextType = 'percent';
      }
    },

    onClickTrailProgressLine() {
      this.showBadge = !this.showBadge;
    },
  },

  /**
   * 使用组件
   */
  components: {},
});
</script>

<style scoped>
@import './styles/trail-progress-line.css';
</style>
